export enum AnalysisReportTypeEnum {
  kwanti = 1,
  hiddenLevers = 2,
  riskalyze = 3,
  other = 4,
}